import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analytics-notes-import-export-table" }
const _hoisted_2 = { class: "title title--h3 analytics-notes-import-export-table__title js-import-export-table-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableAggregated = _resolveComponent("TableAggregated")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_TableAggregated, _mergeProps(_ctx.pdfNoWideTableSplitAttrs, {
      class: ["analytics-notes-import-export-table__table", _ctx.tableClass],
      storePaths: _ctx.storePaths,
      generateColumns: _ctx.generateColumns,
      footerRenderer: _ctx.footerRenderer,
      loadStrategy: _ctx.loadStrategy,
      filterParams: _ctx.filter,
      widthStrategy: "full"
    }), null, 16, ["class", "storePaths", "generateColumns", "footerRenderer", "loadStrategy", "filterParams"])
  ]))
}